import { GlobalState } from '@/store/modules/global/types';

export default {
  loading: false,
  showDrawer: false,
  errorMsgKeys: [],
  searchInput: '',
} as GlobalState;
